import '../Desktop/Styles/Design.scss';
import card from '../../../Assets/Cards/imacDemo.webp';
import { list1, list2 } from '../Desktop/data';
function Design(){
    return(
        <div className="design-desktop">
            <h1>Design, test and ship amazing products at scale with HostDesign iMac App</h1>
            <p>HostDesign Enterprise transforms your design process, leading to better products, faster.</p>
            <div className="content">
                <ul>
                    {list1.map((item) =>{
                        return(
                            <li>
                                {item.icon}
                                <p>{item.title}</p>
                            </li>
                        )
                    })}
                </ul>
                <img src={card} />
                <ul>
                    {list2.map((item) =>{
                        return(
                            <li>
                                {item.icon}
                                <p>{item.title}</p>
                            </li>
                        )
                    })}
                </ul>
            </div>
        </div>
    )
};
export default Design ;